import { generateId, TIPTAP_IMAGE_TYPE } from "./../../ricos-content/index.js";
import { Node_Type } from "./../../ricos-schema/next-schema/index.js";
import { fromTiptapLinkConverter } from "./../../_shared/link/link-converters.js";
import { captionToPlainText } from "./caption-to-plain-text.js";
const fromPmImageAnyState = (pmFigureNode, fromPmNode) => {
  const imageNode = pmFigureNode.content?.find(
    ({ type }) => type === TIPTAP_IMAGE_TYPE
  );
  if (!imageNode) {
    return void 0;
  }
  const { id, ...imageData } = imageNode?.attrs || {};
  const captionNode = fromPmNode(pmFigureNode)?.nodes[0] ?? [];
  const captionPlainText = captionToPlainText(pmFigureNode);
  const { spoiler, ...rest } = imageData.containerData || {};
  const containerData = {
    ...rest,
    ...spoiler?.enabled ? { spoiler: { ...spoiler } } : {}
  };
  const image = imageData.image ? imageData.image : imageData.tempData ? fallbackImage : fallbackImage;
  return {
    type: Node_Type.IMAGE,
    id: id ?? generateId(),
    nodes: captionPlainText ? [captionNode] : [],
    imageData: {
      ...imageData,
      image,
      caption: captionPlainText,
      altText: imageData.altText || void 0,
      decorative: imageData.decorative || void 0,
      disableDownload: imageData.disableDownload || void 0,
      disableExpand: imageData.disableExpand || void 0,
      containerData: Object.keys(containerData).length ? containerData : void 0,
      styles: imageData.styles || void 0,
      link: imageData.link ? fromTiptapLinkConverter(imageData.link) : void 0
    }
  };
};
const fallbackImage = {
  src: {
    url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNgYAAAAAMAASsJTYQAAAAASUVORK5CYII="
  }
};
export {
  fromPmImageAnyState
};
//# sourceMappingURL=from-pm-image-any-state.js.map
